<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import Modal from '@maison/components/common/Modal.vue';

export default {
  components: {
    Modal,
  },

  mixins: [modalMixin],

  props: {
    resetDelay: {
      type: Number,
      default: 0,
    },
    onShow: {
      type: Function,
      default: () => {},
    },
  },

  emits: ['reset'],

  computed: {
    modalOptions() {
      return {
        onShow: () => {
          this.onShow();
          this.initResetDelay();
        },
      };
    },
  },

  methods: {
    reset() {
      Toolkit.helpers.buttons.addLoadingState(this.$refs.resetButtonRef);
      this.$emit('reset');
    },

    initResetDelay() {
      if (!this.resetDelay) {
        return;
      }

      setTimeout(this.reset, this.resetDelay * 1000);
    },
  },
};
</script>

<template>
  <modal
    :id="id"
    :title="$t('EngravingTool.success.title')"
    :options="modalOptions"
    :is-closable="false"
    default
    header-bordered
  >
    <template #content>
      <p>{{ $t('EngravingTool.success.text') }}</p>
    </template>

    <template #footer>
      <button ref="resetButtonRef" type="button" class="btn btn--default btn--negative" @click="reset()">
        <span class="btn__text">{{ $t('EngravingTool.success.reset') }}</span>
      </button>
    </template>
  </modal>
</template>
